export default "__VITE_ASSET__Cbi3Nz29__$_?nuxt_component=async&nuxt_component_name=SvgoFuturesDeliveringDark&nuxt_component_export=default__"